import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/AppTypes";
import { ISCMAssetsMoveSearch, ISCMAssetsMoveDetail, ISCMAssetsMoveStatistics, ISCMAssetsMoveInsert, ISCMAssetsMoveUpdate, ISCMSDcGoodsOne, ISCMSDcSearch, ISCMORVRMTransferSearch, ISCMORVRMTransferDetails } from "./assetsMoveTypes";


export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}


export interface IFmsShopUnitDetail {
    address: string,
    bentity: string,
    branch: string,
    branchList: string,
    code: string,
    contact: string,
    createTime: string,
    createUser: string,
    deleteFlag: string,
    enable: string,
    id: string,
    name: string,
    note: string,
    phone: string,
    shop: string,
    shopCode: string,
    shopList: string,
    shopName: string,
    status: string,
    tel: string,
    updateTime: string,
    updateUser: string,
    ver: string,
}

class AssetsMoveService {
    async page(searchVo: ISCMAssetsMoveSearch) {
        const apiUrl = "/assets/assets/page";
        return await httpRequest.post<IPage<ISCMAssetsMoveDetail>>(apiUrl, searchVo);
    }
    async getDepartmentOutList(searchVo: any) {
        const apiUrl = "/assets/assets/originalDepartmentList";
        return await httpRequest.post<ISCMAssetsMoveDetail[]>(apiUrl, searchVo);
    }
    async pageStatistics(searchVo: ISCMAssetsMoveSearch) {
        const apiUrl = "/assets/assets/total";
        return await httpRequest.post<ISCMAssetsMoveStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/assets/assets/findById/${id}`
        return await httpRequest.get<ISCMAssetsMoveDetail>(apiUrl)
    }
    async insert(insertVo: ISCMAssetsMoveInsert) {
        const apiUrl = '/assets/assets/insert'
        return await httpRequest.post<boolean>(apiUrl, insertVo)
    }
    async update(updateVo: ISCMAssetsMoveInsert) {
        const apiUrl = '/assets/assets/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async export(searchVo: ISCMAssetsMoveSearch) {
        const apiUrl = "/assets/assets/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }

    async print(id: string) {
        const apiUrl = `/assets/assets/print/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async getPrintTip(id: string) {
        const apiUrl = `/assets/assets/printLabelFour/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    // 详情打印按钮
    async printGoodTip(value: any) {
        const apiUrl = `/assets/assets/printLabelFourList`;
        return await httpRequest.post<boolean>(apiUrl,value);
    }
    //资产明细查询接口
    async assetsListDetails(searchVo: ISCMORVRMTransferSearch) {
        const apiUrl = "/assets/assets/detailsPage";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo);
    }
}

export const assetsMoveService = new AssetsMoveService();